@if (mode === 'renderer') {
  <div
    class="heading-text-element"
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft,
      'background-color': element.fields.background
    }"
  >
    <div
      [innerHTML]="
        (element.fields.translate
          ? element.fields.title.i18n?.[currentLang]
          : element.fields.title.value || element.fields.title.value === ''
            ? element.fields.title.value
            : element.fields.title) | safeHtml
      "
    ></div>
    <div
      [innerHTML]="
        (element.fields.translate
          ? element.fields.text.i18n?.[currentLang]
          : element.fields.text.value || element.fields.text.value === ''
            ? element.fields.text.value
            : element.fields.text) | safeHtml
      "
    ></div>
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Content</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="element.fields.translate"
                  id="translate"
                  (ngModelChange)="changeTranslate()"
                />
                <label class="form-check-label" for="translate">Translate</label>
              </div>
            </div>
            @if (element.fields.translate) {
              <lib-gung-accordion [closeOthers]="false">
                @for (lang of translateLangs; track lang) {
                  <lib-gung-accordion-item [collapsed]="true">
                    <ng-template libGungAccordionHeader>{{ lang.toUpperCase() }}</ng-template>
                    <ng-template libGungAccordionBody class="acc-body">
                      <div class="col-12 mb-2">
                        <lib-gung-html-editor
                          [gungTranslate]="'TITLE'"
                          placeholder="Type the content here!"
                          [angularEditorConfig]="angularEditorConfig"
                          [(ngModel)]="element.fields.title.i18n[lang]"
                          [backgroundColor]="element.fields.background"
                        ></lib-gung-html-editor>
                      </div>
                      <div class="col-12 mb-2">
                        <lib-gung-html-editor
                          [gungTranslate]="'TEXT'"
                          [angularEditorConfig]="angularEditorConfig"
                          placeholder="Type the content here!"
                          [(ngModel)]="element.fields.text.i18n[lang]"
                          [backgroundColor]="element.fields.background"
                        ></lib-gung-html-editor>
                      </div>
                    </ng-template>
                  </lib-gung-accordion-item>
                }
              </lib-gung-accordion>
            } @else {
              <div class="col-12">
                @if (element.fields.title.value || element.fields.title.value === '') {
                  <lib-gung-html-editor
                    [gungTranslate]="'TITLE'"
                    placeholder="Type the content here!"
                    [angularEditorConfig]="angularEditorConfig"
                    [(ngModel)]="element.fields.title.value"
                    [backgroundColor]="element.fields.background"
                  ></lib-gung-html-editor>
                } @else {
                  <lib-gung-html-editor
                    [gungTranslate]="'TITLE'"
                    [angularEditorConfig]="angularEditorConfig"
                    placeholder="Type the content here!"
                    [(ngModel)]="element.fields.title"
                    [backgroundColor]="element.fields.background"
                  ></lib-gung-html-editor>
                }
              </div>
              <div class="col-12">
                @if (element.fields.text.value || element.fields.text.value === '') {
                  <lib-gung-html-editor
                    [gungTranslate]="'TEXT'"
                    placeholder="Type the content here!"
                    [angularEditorConfig]="angularEditorConfig"
                    [(ngModel)]="element.fields.text.value"
                    [backgroundColor]="element.fields.background"
                  ></lib-gung-html-editor>
                } @else {
                  <lib-gung-html-editor
                    [gungTranslate]="'TEXT'"
                    [angularEditorConfig]="angularEditorConfig"
                    placeholder="Type the content here!"
                    [(ngModel)]="element.fields.text"
                    [backgroundColor]="element.fields.background"
                  ></lib-gung-html-editor>
                }
              </div>
            }
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Styles</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12">
              <lib-dynamic-page-element-margin-padding
                [(marginTop)]="element.fields.marginTop"
                [(marginRight)]="element.fields.marginRight"
                [(marginBottom)]="element.fields.marginBottom"
                [(marginLeft)]="element.fields.marginLeft"
                [(paddingTop)]="element.fields.paddingTop"
                [(paddingRight)]="element.fields.paddingRight"
                [(paddingBottom)]="element.fields.paddingBottom"
                [(paddingLeft)]="element.fields.paddingLeft"
              ></lib-dynamic-page-element-margin-padding>
            </div>
            <div class="col-12">
              <div class="d-flex color-dp-input">
                <lib-gung-text-input
                  [gungTranslate]="'BACKGROUND'"
                  [(ngModel)]="element.fields.background"
                ></lib-gung-text-input>
                <input class="input-color" type="color" [(ngModel)]="element.fields.background" />
              </div>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="heading-preview">
    <div class="heading-preview-title">
      <i class="fa-solid fa-heading"></i>
      NEW TITLE
    </div>
    <div class="heading-preview-line">FREE TEXT</div>
    <div class="heading-preview-line">FREE TEXT</div>
  </div>
}
